import styled from 'styled-components';
import theme from 'theme';
import { Close } from '@styled-icons/ionicons-solid';

export const ModalHeaderBar = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    color: ${theme.sherpaBlue};
    font-size: 18px;
`;

export const Title = styled.div`
    margin: 0;
    font-weight: 600;
`;

export const CloseButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
`;

export const CloseIcon = styled(Close)`
    color: black;
`;
